import type { MigrationJob } from '../types/modpackMigration';

export const migrationNeedsStaffApproval = (job: MigrationJob) => job.state === 'pending_staff_approval'
  && job.staff_approval?.state === 'pending' && !job.cancel_requested;

export function migrationApprovalError(job: MigrationJob): string | null {
  if (!migrationNeedsStaffApproval(job)) return 'This request is no longer awaiting a Staff Manager decision.';
  if (!/^[a-f0-9]{64}$/.test(job.staff_approval!.request_digest)) return 'The request identity is incomplete. Refresh before deciding.';
  const request = job.request;
  if (!request?.storage_id || !request.storage_path || !request.backup_storage_id || !request.backup_storage_path
    || !request.source_instance_path || !request.source_game_root || !request.memory)
    return 'The recorded locations and memory budget must be available before approval.';
  const memory = request.memory;
  if ([memory.total_bytes, memory.allocated_bytes, memory.reserved_bytes, memory.required_bytes, memory.projected_available_bytes]
    .some(value => typeof value !== 'number' || !Number.isFinite(value)))
    return 'The request is missing capacity information. Ask for a fresh migration inspection.';
  if (request.transfer_bytes != null && (typeof request.transfer_bytes !== 'number' || !Number.isFinite(request.transfer_bytes) || request.transfer_bytes < 0))
    return 'The recorded transfer estimate is invalid. Ask for a fresh migration inspection.';
  if (!memory.sufficient && !request.memory_override?.trim()) return 'This request exceeds the memory budget without an override reason.';
  return null;
}

export function migrationApprovalUnchanged(job: MigrationJob | undefined, reviewed: { id: string; digest: string } | null): boolean {
  return !!job && !!reviewed && migrationNeedsStaffApproval(job) && reviewed.id === job.id
    && reviewed.digest === job.staff_approval?.request_digest;
}
